export default __webpack_public_path__ + "static/media/52.992f4b58.png";